/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * State of an organization's event clock as seen by a competitor.
 * @export
 */
export const ClockState = {
    Waiting: 'waiting',
    Running: 'running',
    Finished: 'finished'
} as const;
export type ClockState = typeof ClockState[keyof typeof ClockState];


export function instanceOfClockState(value: any): boolean {
    for (const key in ClockState) {
        if (Object.prototype.hasOwnProperty.call(ClockState, key)) {
            if (ClockState[key as keyof typeof ClockState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClockStateFromJSON(json: any): ClockState {
    return ClockStateFromJSONTyped(json, false);
}

export function ClockStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClockState {
    return json as ClockState;
}

export function ClockStateToJSON(value?: ClockState | null): any {
    return value as any;
}

export function ClockStateToJSONTyped(value: any, ignoreDiscriminator: boolean): ClockState {
    return value as ClockState;
}

